import {} from "@redotech/money/currencies"; // for TS2742
import { baseServiceInvoiceSchema } from "@redotech/redo-billing-common/service-invoice";
import * as z from "zod/v4";

export const getFinalizedOrderTrackingInvoices = {
  name: "getFinalizedOrderTrackingInvoices" as const,
  input: z.null(),
  output: z.array(baseServiceInvoiceSchema),
};
